import { render, staticRenderFns } from "./PaddockSearch_v3.vue?vue&type=template&id=3122075e&"
import script from "./PaddockSearch_v3.vue?vue&type=script&lang=ts&"
export * from "./PaddockSearch_v3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3122075e')) {
      api.createRecord('3122075e', component.options)
    } else {
      api.reload('3122075e', component.options)
    }
    module.hot.accept("./PaddockSearch_v3.vue?vue&type=template&id=3122075e&", function () {
      api.rerender('3122075e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/PaddockSearch_v3.vue"
export default component.exports